import React from 'react';
import { AgConversation, AgFinancing } from '@indigo-ag/schema';

import { createStylesHook, LoadingWrapper } from 'shared';
import { Conversations } from '../Conversations/Conversations';
import { getConversationsForFinancing } from 'features/brazil-grower/queries';

const useStyles = createStylesHook({
  conversationContainer: {
    minHeight: '50vh',
    display: 'flex',
    flexDirection: 'column'
  }
});

interface ConversationPageProps {
  agFinancingId: AgFinancing['id'];
}

export const ConversationPage: React.FunctionComponent<ConversationPageProps> = ({ agFinancingId }) => {
  /**
   * Styles
   */
  const classes = useStyles();

  return (
    <LoadingWrapper
      query={getConversationsForFinancing}
      queryOptions={{ variables: { agFinancingId }, pollInterval: 30000 }}
    >
      {({ data }: { data: { financingAgFinancingConversations: AgConversation[] } }) => {
        const conversations = data?.financingAgFinancingConversations || [];

        return (
          <div className={classes.conversationContainer}>
            <Conversations conversations={conversations} />
          </div>
        );
      }}
    </LoadingWrapper>
  );
};
